import { render, staticRenderFns } from "./ExtruderMachine.vue?vue&type=template&id=eadbf2b0&"
import script from "./ExtruderMachine.vue?vue&type=script&lang=js&"
export * from "./ExtruderMachine.vue?vue&type=script&lang=js&"
import style0 from "./ExtruderMachine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports